import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { deliveryTrackingService } from '../services/delivery-tracking.service';
import type { UpdateDeliveryTrackingPayload } from '../types/delivery-tracking.types';

export function useUpdateDeliveryTracking() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateDeliveryTrackingPayload) =>
      deliveryTrackingService.updateDeliveryTracking(payload),
    onSuccess: (_, { orderId }) => {
      queryClient.invalidateQueries({ queryKey: ['order-delivery-tracking', orderId] });
      queryClient.invalidateQueries({ queryKey: ['order', orderId] });
      toast.success('Suivi de livraison mis à jour');
    },
    onError: () => {
      toast.error('Erreur lors de la mise à jour du suivi de livraison');
    },
  });
}
